import { normalizeText } from "../../../shared/util/normalizeText";
import { FinancingBanks } from "../../../shared/data/types";

export const getFinancingAvatar = (bank: FinancingBanks) => {
  const normBank = normalizeText(bank) as
    | "btg"
    | "itau"
    | "sol agora"
    | "solagora"
    | "solfacil"
    | "losango"
    | "santander"
    | "bv financeira"
    | "bv"
    | "revo"
    | "azume cred"
    | "azumecred"
    | "azumecredi"
    | "azume credi";

  switch (normBank) {
    case "btg":
      return "avatar-btg.png";

    case "itau":
      return "avatar-itau.png";

    case "sol agora":
      return "avatar-sol-agora.png";

    case "solagora":
      return "avatar-sol-agora.png";

    case "solfacil":
      return "avatar-solfacil.png";

    case "losango":
      return "avatar-losango.png";

    case "santander":
      return "avatar-santander.png";

    case "bv financeira":
      return "avatar-bv-financeira.png";

    case "bv":
      return "avatar-bv-financeira.png";

    case "revo":
      return "avatar-revo.png";

    default:
      return "avatar-azume-logo-only.png";
  }
};
